// --------------------------------------------------------------
// Created On: 2025-09-30
// Author: Zachary Thomas
//
// Last Modified: 2025-11-05
// Modified By: Zachary Thomas
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import Card from "../../../components/Card/Card";
import Error from "../../../components/Error/Error";
import styles from "./MfaRegistrationVerificationForm.module.scss";

// Form for a user to verify that their phone number registration for MFA was successful.
export default function MfaRegistrationVerificationForm(props: Props): Component {
  // Check if the user pressed enter, if they did we attempt to verify phone number.
  function checkPressEnter(e: React.KeyboardEvent): void {
    if (e.key === "Enter") {
      props.onSubmit();
    }
  }

  return (
    <form className={styles.body} onSubmit={(e) => e.preventDefault()} onKeyDown={(e) => checkPressEnter(e)}>
      <Card title="MFA Registration">
        <div className="px-3 px-lg-5 mb-4">
          <p className="mt-2">Please enter the verification code that was sent to your mobile phone number.</p>

          <input
            data-test="mfa-verification-code-input"
            className="form-control mt-2 mb-4"
            id="mfa-verification-code-text"
            aria-describedby="Verification Code"
            placeholder="Enter verification code..."
            value={props.verificationCode}
            disabled={props.disabled}
            onChange={(e) => props.onChangeVerificationCode(e.target.value)}
          />

          <Error message={props.errorMessage} />

          <div className="row g-4">
            <div className="col-12 col-lg-4">
              <button
                data-test="cancel-mfa-phone-register-button"
                type="submit"
                id="cancel-mfa-register"
                className={`${styles.btn} btn btn-secondary`}
                disabled={props.disabled}
                onClick={() => props.onCancel()}
              >
                Change Phone Number
              </button>
            </div>

            <div className="col-12 col-lg-4">
              <button
                data-test="login-button"
                type="submit"
                id="submit-login"
                className={`${styles.btn} btn btn-primary`}
                disabled={props.disabled}
                onClick={() => props.onResend()}
              >
                Resend Code
              </button>
            </div>

            <div className="col-12 col-lg-4">
              <button
                data-test="login-button"
                type="submit"
                id="submit-login"
                className={`${styles.btn} btn btn-success`}
                disabled={props.disabled}
                onClick={() => props.onSubmit()}
              >
                Verify Phone Number
              </button>
            </div>
          </div>
        </div>
      </Card>
    </form>
  );
}

interface Props {
  errorMessage: string;
  verificationCode: string;
  disabled?: boolean;
  onChangeVerificationCode: (phoneNumber: string) => void;
  onCancel: () => void;
  onResend: () => void;
  onSubmit: () => void;
}
